/**
 * Author:hong.rong
 * Desc:
 * Date:2022-10-11
 */

import React, { useMemo, useState, useRef, useEffect } from 'react'
import classnames from 'classnames'
// import { Modal, Popover, Tooltip } from 'antd'
import { Modal, Popover } from 'antd'
import axios from 'axios'
import { useTranslation } from '@/libs/next-lang'
import IconSvg from '@/components/IconSvg'
import { getSystemLocale } from '@/utils'
import { LOCAL_ENUM } from '@/constants'
// import Tutorial from './Tutorial';
import Guide from './Guide'
import { getUserStorage, setUserStorage } from '@/services/common'
import styles from './index.module.less'

interface Props {
  qrcodeUrl?: string
  phone?: string
  wechat?: string
  isGraphic: boolean
}

const STORAGE_KEY = 'user.canva.template.guide.record'

const TemplateEditorHelper = React.memo((props: Props) => {
  const {
    // qrcodeUrl = 'https://static.creativebooster.com/ad-web/canva/wechat_qr.png',
    // phone = '15192595108',
    // wechat = 'mao727134008',
    isGraphic,
  } = props

  const [visibleTutorial, setVisibleTutorial] = useState(false)
  const [tutorList, setTutorList] = useState([])
  const [visibleContactUs, setVisibleContactUs] = useState(false)

  const [visibleTutorialTip, setVisibleTutorialTip] = useState(false)
  const [visibleContactUsTip, setVisibleContactUsTip] = useState(false)

  const popoverContainerRef = useRef(null)

  const { t } = useTranslation(['components'])

  useEffect(() => {
    async function getStorage() {
      const { data: result } = await axios.get(
        `https://static.creativebooster.com/common/tutorial/t.json?t=${Date.now()}`,
        { withCredentials: false },
      )
      const lang = getSystemLocale() || LOCAL_ENUM.ZH_CN
      const tecData = result?.[lang]
      const tecList = isGraphic ? tecData?.TEC_CANVA_GRAPIC : tecData?.TEC_CANVA_VIDEO
      if (Array.isArray(tecList) && tecList.length > 0) {
        const newTecList: any = tecList.map((item: any, i: number) => ({
          id: `${i + 1}`,
          thumbnail: `${item.src}?x-oss-process=video/snapshot,t_0,w_240,m_fast`,
          poster: `${item.src}?x-oss-process=video/snapshot,t_0,m_fast`,
          ...item,
        }))
        setTutorList(newTecList)
      }
      const { data = {} } = await getUserStorage({
        keys: [STORAGE_KEY],
      })
      if (data?.code === 0) {
        const result = data?.result || {}
        setVisibleTutorial(result[STORAGE_KEY] !== '1')
      }
    }
    getStorage()
  }, [])

  /**
   * 我学会了
   */
  const onKnown = async () => {
    setVisibleTutorial(false)
    setUserStorage({
      key: STORAGE_KEY,
      value: '1',
    })
  }

  // 联系我们内容
  const contactUsContent = useMemo(() => {
    return (
      <div className={styles.application}>
        <span className="close-button" onClick={() => setVisibleContactUs(false)}>
          <IconSvg type="icon-shanchu1" />
        </span>
        <div className="title">Creative Booster</div>
        <div className="title">{t('components:t21')}</div>
        <img
          style={{ marginTop: 12, marginBottom: 12 }}
          width={120}
          height={120}
          src="//static.creativebooster.com/ad-web/pay.png"
        />
        <div className="remark">{t('components:t22')}</div>
        <div className="remark">{t('components:t23')}</div>
      </div>
    )
    // return (
    //   <div className="contact-us-content">
    //     <span className="close-button" onClick={() => setVisibleContactUs(false)}>
    //       <IconSvg type="icon-shanchu1" />
    //     </span>
    //     <div className="qr-code">
    //       <img src={qrcodeUrl} width={100} height={100} />
    //     </div>
    //     <div className="detail">
    //       <div style={{ fontSize: 14, fontWeight: 600, color: '#1D2129', marginBottom: 5 }}>
    //         联系客服
    //       </div>
    //       <div style={{ whiteSpace: 'nowrap' }}>电话：{phone}</div>
    //       <div style={{ whiteSpace: 'nowrap' }}>微信号：{wechat}</div>
    //     </div>
    //   </div>
    // );
  }, [])

  return (
    <>
      <div
        ref={popoverContainerRef}
        className={classnames('relative', styles.renderPopoverContainer)}
      />
      <div className={styles['template-editor-help']}>
        <div
          className={classnames('tutorial', {
            active: visibleTutorial || visibleTutorialTip,
          })}
          onClick={() => {
            setVisibleTutorial(true)
            setVisibleTutorialTip(false)
          }}
          onMouseEnter={() => setVisibleTutorialTip(true)}
          onMouseLeave={() => setVisibleTutorialTip(false)}
        >
          <IconSvg className="icon" type="icon-jiaocheng" />
          <div className="txt">{t('components:t104')}</div>
        </div>
        <Popover
          // @ts-ignore
          getPopupContainer={() => popoverContainerRef.current}
          overlayClassName={classnames(styles['contact-us-popover'])}
          overlayStyle={{
            width: 260,
            textAlign: 'center',
          }}
          content={contactUsContent}
          placement="left"
          trigger="click"
          open={visibleContactUs}
          onOpenChange={(visible: boolean) => {
            setVisibleContactUs(visible)
            if (visible) {
              setVisibleContactUsTip(false)
            }
          }}
        >
          <div
            className={classnames('contact-us', {
              active: visibleContactUs || visibleContactUsTip,
            })}
            onMouseEnter={() => setVisibleContactUsTip(true)}
            onMouseLeave={() => setVisibleContactUsTip(false)}
          >
            <IconSvg className="icon" type="icon-lianxi" />
            <div className="txt">{t('components:t156')}</div>
          </div>
        </Popover>
        <Modal
          centered
          destroyOnClose
          open={visibleTutorial}
          className={styles['tutorial-modal']}
          footer={null}
          bodyStyle={{ padding: 0 }}
          width={960}
          // @ts-ignore
          getContainer={() => popoverContainerRef.current}
          // onOk={() => {}}
          onCancel={onKnown}
          // okText={t('components:t59')}
          // cancelText={t('components:t85')}
        >
          <Guide dataSource={tutorList} onCancel={onKnown} translateTxt={t} />
        </Modal>
      </div>
      {/* <Tutorial /> */}
    </>
  )
})

export default TemplateEditorHelper
